import styled from 'styled-components';

export const Container = styled.div`
  padding: 8px;
  border-radius: 4px;
  background: #f9eaec;
  font-size: 12px;
  line-height: 16px;
`;
